export { INTERNAL_ENV_PARAMS as Environment } from './environment.dev.wds';
